import { tryFormatThousands } from '@wwe-portal/utils/format';
import { shortenNumber } from '@wwe-portal/utils/number';
import { ComponentProps, FC, useMemo } from 'react';
import { TextChange } from './text-change';

interface NumberDiffProps extends ComponentProps<'div'> {
  oldValue: number | undefined;
  newValue: number | undefined;
  showBaseDiff?: boolean;
  diffOnNewLine?: boolean;
}

export const NumberDiff: FC<NumberDiffProps> = ({
  oldValue,
  newValue,
  showBaseDiff = true,
  diffOnNewLine = false,
  ...props
}) => {
  const diff = useMemo(() => {
    if (newValue == null || oldValue == null) {
      return null;
    }
    return newValue - oldValue;
  }, [newValue, oldValue]);

  const changed = useMemo(() => {
    if (diff != null) {
      return diff > 0 ? 'added' : 'removed';
    }

    if (newValue == null && oldValue == null) {
      return 'none';
    }

    if (newValue == null) {
      return 'removed';
    }

    return 'added';
  }, [newValue, oldValue, diff]);

  return (
    <div {...props}>
      <TextChange changed={changed} diff={diff} enableDiff={showBaseDiff}>
        {tryFormatThousands(newValue)}
      </TextChange>

      {diff != null && diff !== 0 && (
        <TextChange changed={changed} diff={diff}>
          {diffOnNewLine ? <br /> : ' '}({diff > 0 ? '+' : ''}
          {shortenNumber(diff)}){' '}
        </TextChange>
      )}
    </div>
  );
};
